"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The ExcessiveDownloadResult model module.
 * @module model/ExcessiveDownloadResult
 * @version 1.1.3-alpha.1
 */
class ExcessiveDownloadResult {
  /**
   * Constructs a new <code>ExcessiveDownloadResult</code>.
   * @alias module:model/ExcessiveDownloadResult
   */
  constructor() {
    ExcessiveDownloadResult.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>ExcessiveDownloadResult</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ExcessiveDownloadResult} obj Optional instance to populate.
   * @return {module:model/ExcessiveDownloadResult} The populated <code>ExcessiveDownloadResult</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ExcessiveDownloadResult();
      if (data.hasOwnProperty('isExcessive')) {
        obj['isExcessive'] = _ApiClient.default.convertToType(data['isExcessive'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>ExcessiveDownloadResult</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ExcessiveDownloadResult</code>.
   */
  static validateJSON(data) {
    return true;
  }
}

/**
 * Indicates if the user has downloaded excessively in this media.
 * @member {Boolean} isExcessive
 */
ExcessiveDownloadResult.prototype['isExcessive'] = undefined;
var _default = exports.default = ExcessiveDownloadResult;